import { ONE_TRUST_TARGETING_GROUP_ID } from "./constants.js";
const getIsOneTrustGroupEnabled = (groups, groupId) => {
  const groupArray = groups.split(",");
  const groupKeyValue = groupArray.find(
    (group) => group.startsWith(`${groupId}:`)
  );
  if (groupKeyValue) {
    const value = groupKeyValue.split(":")[1];
    return value === "1";
  }
  return false;
};
const getIsOneTrustTargetingEnabled = (groups) => {
  return getIsOneTrustGroupEnabled(groups, ONE_TRUST_TARGETING_GROUP_ID);
};
export {
  getIsOneTrustGroupEnabled,
  getIsOneTrustTargetingEnabled
};
